
    import './styles.scoped.css';
    export default {
  "button-trigger": "awsui_button-trigger_18eso_15t5f_17",
  "arrow": "awsui_arrow_18eso_15t5f_17",
  "in-filtering-token-root": "awsui_in-filtering-token-root_18eso_15t5f_77",
  "in-filtering-token-nested": "awsui_in-filtering-token-nested_18eso_15t5f_77",
  "has-caret": "awsui_has-caret_18eso_15t5f_113",
  "placeholder": "awsui_placeholder_18eso_15t5f_116",
  "pressed": "awsui_pressed_18eso_15t5f_129",
  "disabled": "awsui_disabled_18eso_15t5f_132",
  "in-filtering-token": "awsui_in-filtering-token_18eso_15t5f_77",
  "readonly": "awsui_readonly_18eso_15t5f_153",
  "invalid": "awsui_invalid_18eso_15t5f_174",
  "warning": "awsui_warning_18eso_15t5f_183",
  "custom-option": "awsui_custom-option_18eso_15t5f_192",
  "inline-tokens": "awsui_inline-tokens_18eso_15t5f_197",
  "grouped": "awsui_grouped_18eso_15t5f_200",
  "grouped-horizontal-first": "awsui_grouped-horizontal-first_18eso_15t5f_206",
  "grouped-horizontal-middle": "awsui_grouped-horizontal-middle_18eso_15t5f_210",
  "grouped-horizontal-last": "awsui_grouped-horizontal-last_18eso_15t5f_216",
  "grouped-vertical-first": "awsui_grouped-vertical-first_18eso_15t5f_220",
  "grouped-vertical-middle": "awsui_grouped-vertical-middle_18eso_15t5f_224",
  "grouped-vertical-last": "awsui_grouped-vertical-last_18eso_15t5f_230"
};
  